// extracted by mini-css-extract-plugin
module.exports = {"container":"PrinterErrorModal_container__3WT4t","close":"PrinterErrorModal_close__2fa4-","title":"PrinterErrorModal_title__1d_Mq"};